import { ArrangementObjectEntityWidget } from "../entity/widget/ArrangementObjectEntityWidget";
import { ArrangementGroupEntityWidget } from "../entity/widget/ArrangementGroupentityWidget";
import { JoineryEntityWidget } from "../entity/widget/JoineryEntityWidget";
import { TechnicalElementEntityWidget } from "../entity/widget/TechnicalElementEntityWidget";
import { CameraEntityWidget } from "../entity/widget/CameraEntityWidget";
import { SunEntityWidget } from "../entity/widget/SunEntityWidget";
import { CommentEntityWidget } from "../entity/widget/CommentEntityWidget";
import { WallEntityWidget } from "../entity/widget/WallEntityWidget";
import { RoomEntityWidget } from "../entity/widget/RoomEntityWidget";
import { StaircaseEntityWidget } from "../entity/widget/StaircaseEntityWidget";
import { GeometryGroupEntityWidget } from "../entity/widget/GeometryGroupEntityWidget";
import { GeometryPrimitiveEntityWidget } from "../entity/widget/GeometryPrimitiveEntityWidget";
import { ArrangementGroup, ArrangementObject, Comment, Entity, GeometryGroup, GeometryPrimitive, Joinery, RenderCamera, Room, SceneConstants, Staircase, Sun, TechnicalElement, Wall } from "@rhinov/savane-js";
import { EntityWidget } from "../entity/widget/EntityWidget";

export class PropertiesPanelController {

    entity: Entity;
    panel: any;
    arrangement: any;
    deliverable: any;
    widget: EntityWidget | null = null;
    user: any;
    designer: any;
    draggingTulip: boolean = false;
    lastPositionX: number = 0;
    openAssetDetailCallback: CallableFunction;
    lastPositionY = 0;

    element: HTMLElement = document.getElementById("panelPropMovable")!;

    mousedown = (event: MouseEvent) => {
        if (event.button === 0) {
            if (event.layerY <= 32) {
                this.lastPositionX = event.x;
                this.lastPositionY = event.y;
                this.draggingTulip = true;
            }
        }
    }

    mouseup = (event: MouseEvent) => {
        if (event.button === 0) {
            this.draggingTulip = false;
        }
    }

    mousemove = (event: MouseEvent) => {
        if (this.draggingTulip) {
            var deltaX = event.x - this.lastPositionX;
            var deltaY = event.y - this.lastPositionY;

            this.lastPositionX = event.x;
            this.lastPositionY = event.y;

            var offset = {left: this.element.offsetLeft,  top: this.element.offsetTop};

            offset.left += deltaX;
            offset.top += deltaY;

            this.element.style.top = offset.top + 'px';
            this.element.style.left = offset.left + 'px';
        }
    }

    mouseleave = (event: MouseEvent) => {
        if (this.draggingTulip) {
            var deltaX = event.x - this.lastPositionX;
            var deltaY = event.y - this.lastPositionY;

            this.lastPositionX = event.x;
            this.lastPositionY = event.y;

            var offset = {left: this.element.offsetLeft,  top: this.element.offsetTop};

            offset.left += deltaX;
            offset.top += deltaY;

            this.element.style.top = offset.top + 'px';
            this.element.style.left = offset.left + 'px';
        }
    }
    
    constructor (entity: Entity, panel: any, deliverable: any, designer: any, openAssetDetailCallback: CallableFunction, user: any) {
        this.entity = entity;
        this.panel = panel;
        this.deliverable = deliverable;
        this.widget;
        this.user = user;
        this.designer = designer;
        this.draggingTulip = false;
        this.lastPositionX = 0;
        this.openAssetDetailCallback = openAssetDetailCallback;
        this.lastPositionY = 0;

        this.element = document.getElementById("panelPropMovable")!;
        this.element.addEventListener("mousedown", this.mousedown);
        this.element.addEventListener("mouseup", this.mouseup);
        this.element.addEventListener("mousemove", this.mousemove);
        this.element.addEventListener("mouseleave", this.mousemove);
        
        let tulip = document.getElementById('properties-panel');
        this.setWidget();
        if ((this.widget as any).html.length > 0) {
            (this.widget as any).html((html: string) => {
                this.element.insertAdjacentHTML('beforeend', html);
                setTimeout(() => {
                    if (tulip) { 
                        tulip.classList.remove('hide');
                    }
                    this.init(this.init.bind(this));
                }, 100);
            })
        } else {
            this.element.insertAdjacentHTML('beforeend', (this.widget! as any).html());
            setTimeout(() => {
                if (tulip) {
                    tulip.classList.remove('hide');
                }
                this.init(this.init.bind(this));
            }, 100);
        }
    }

    init(callback: CallableFunction) {
        var list = document.getElementById('propertiesList');
        var panel = document.getElementById('panelPropMovable');
        if (!list || !panel || !this.widget) {
            return setTimeout(callback, 50);
        }
        this.widget.controller.initColorPicker()
        this.widget.setListener();
        this.widget.controller.updateProperties(this.panel.key);
        panel.style.top = "100px";
        panel.style.left = "100px";
        let rect = panel.getBoundingClientRect();
        if (rect) {
            var maxWidth = rect.width;
            var maxHeight = rect.height;
            panel.style.top = (window.innerHeight - maxHeight) / 2 + 54 + 'px';
            panel.style.left = (window.innerWidth - maxWidth) / 2 + 'px';
            panel.style.transform = 'none';
        }
        var max = window.innerHeight - panel.getBoundingClientRect().top;
        panel.style.maxHeight = max + 'px';
        list.style.maxHeight = max - 100 + "px";
    }

    setWidget() {
        switch(this.entity.entityType) 
        {
            case SceneConstants.EntityType.ArrangementObject:
                this.widget = new ArrangementObjectEntityWidget(this.entity as ArrangementObject, this.panel, this.deliverable, this.designer, this.openAssetDetailCallback);
                break;
            case SceneConstants.EntityType.Sun:
                this.widget = new SunEntityWidget(this.entity as Sun, this.panel);
                break;
            case SceneConstants.EntityType.RenderCamera:
                this.widget = new CameraEntityWidget(this.entity as RenderCamera, this.panel, this.deliverable);
                break;
            case SceneConstants.EntityType.Wall:
                this.widget = new WallEntityWidget(this.entity as Wall, this.panel, this.deliverable, this.openAssetDetailCallback);
                break;
            case SceneConstants.EntityType.ArrangementGroup:
                this.widget = new ArrangementGroupEntityWidget(this.entity as ArrangementGroup, this.panel, this.deliverable);
                break;
            case SceneConstants.EntityType.GeometryPrimitive:
                this.widget = new GeometryPrimitiveEntityWidget(this.entity as GeometryPrimitive, this.panel, this.deliverable);
                break;
            case SceneConstants.EntityType.GeometryGroup:
                this.widget = new GeometryGroupEntityWidget(this.entity as GeometryGroup, this.panel, this.deliverable);
                break;
            case SceneConstants.EntityType.Joinery:
                this.widget = new JoineryEntityWidget(this.entity as Joinery, this.panel, this.deliverable, this.openAssetDetailCallback);
                break;
            case SceneConstants.EntityType.Staircase:
                this.widget = new StaircaseEntityWidget(this.entity as Staircase, this.panel, this.deliverable, this.openAssetDetailCallback);
                break;
            case SceneConstants.EntityType.TechnicalElement:
                this.widget = new TechnicalElementEntityWidget(this.entity as TechnicalElement, this.panel, this.deliverable, this.openAssetDetailCallback);
                break;
            case SceneConstants.EntityType.Room:
                this.widget = new RoomEntityWidget(this.entity as Room, this.panel, this.deliverable, this.openAssetDetailCallback);
                break;
            case SceneConstants.EntityType.Comment:
                this.widget = new CommentEntityWidget(this.entity as Comment, this.panel);
                break;
        }
        var contentFactory = false;
        if (this.user) {
            contentFactory = this.user.customers_groups_id === 193 || this.user.mail.indexOf('@rhinov.fr') !== -1;
        }
        if (contentFactory && this.widget && this.widget.controller.dropDownDatas.cameraQualities.length <= 5) {
            this.widget.controller.dropDownDatas.cameraQualities.push({ name: 'Bazooka', value: '5' });
        }

    }

    //On destroy
    destroy() {
        if (this.widget) this.widget.removeListener();
        this.element.removeEventListener("mousedown", this.mousedown);
        this.element.removeEventListener("mouseup", this.mouseup);
        this.element.removeEventListener("mousemove", this.mousemove);
        this.element.removeEventListener("mouseleave", this.mousemove);
    }
}